<script lang="ts" setup>
import AuthScope from '~/enums/auth-scope'
import { useSpecialistIssuesStore } from '~/store/specialist-issues'
import { useSpecialistsStore } from '~/store/specialists'

const specialistsStore = useSpecialistsStore()
const specialistIssuesStore = useSpecialistIssuesStore()
const { getIssues } = storeToRefs(specialistIssuesStore)

async function loadData (): Promise<void> {
  specialistsStore.page.number = 1
  await specialistsStore.fetchSpecialists(AuthScope.Client)
}

// onMounted(async (): Promise<void> => {
//   await specialistIssuesStore.fetchIssues()
// })
</script>

<template>
  <div class="hidden rounded-3xl bg-white p-5 md:block">
    <strong class="text-[22px] font-medium leading-5">Поможем решить вашу проблему</strong>

    <FreeGallery class="mt-4">
      <a
        v-for="x in getIssues"
        :key="x.id"
        class="
          mr-4 rounded-2xl bg-main-light-gray px-4 py-3 text-base leading-6 tracking-[-0.01em] text-main-dark
          !no-underline transition-colors duration-300 hover:!bg-main-green hover:!text-white
        "
        :class="{'!bg-main-green !text-white': specialistsStore.filter.issuesId === x.id}"
        href="#"
        @click.prevent="
          specialistsStore.filter.issuesId === x.id
            ? specialistsStore.filter.issuesId = null
            : specialistsStore.filter.issuesId = x.id; loadData()
        "
      >
        {{ x.attributes.name }}
      </a>
    </FreeGallery>
  </div>
</template>
